import { IConfigurationService, IConfigurationOverrides, IConfigurationValue } from '../interfaces';
import { getConfigurationValue } from '../utils';
/**
 * TODO: Move to workspace module
 */
export class MockConfigurationService implements IConfigurationService {
    public _serviceBrand: any;
    public constructor(private configuration: any = {}) { }
    public inspect<T>(key: string, overrides?: IConfigurationOverrides): any {
        return {
            value: getConfigurationValue<T>(this.getValue(), key),
            default: getConfigurationValue<T>(this.getValue(), key),
            user: getConfigurationValue<T>(this.getValue(), key),
            workspaceFolder: void 0, folder: void 0,
        };
    }
    public keys() { return { default: [], user: [], workspace: [], workspaceFolder: [] }; }
    public getValue(): any;
    public getValue(value: string): any;
    public getValue(value?: any): any {
        if (!value) {
            return this.configuration;
        }
        const valuePath = (<string>value).split('.');
        let object = this.configuration;
        while (valuePath.length && object) {
            object = object[valuePath.shift()];
        }

        return object;
    }
    public updateValue(): Promise<void> { return null; }
    public getConfigurationData(): any { return null; }
    public onDidChangeConfiguration() { return { dispose() { } }; }
    public reloadConfiguration() { return null; }
}
